import { render, staticRenderFns } from "./ClothLoader.vue?vue&type=template&id=24fd5286&"
import script from "./ClothLoader.vue?vue&type=script&lang=js&"
export * from "./ClothLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports